var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.url,"width":"100%","height":`${_vm.porlet.attr.height || '575'}px`,"frameborder":"0","allowfullscreen":"","aria-hidden":"false","tabindex":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }